import map from 'lodash/map';
import { normalize } from 'normalizr';
import { receiveEntities } from '../../entities';
import { statisticListSchema } from '../../../schemas/statistic';

import { getEndpoint, getHeaders } from '../../../helpers/endpoint';

export const REQUEST_STATS_REGISTRATIONS = 'REQUEST_STATS_REGISTRATIONS';
export const SUCCESS_FETCH_STATS_REGISTRATIONS = 'SUCCESS_FETCH_STATS_REGISTRATIONS';
export const FAIL_FETCH_STATS_REGISTRATIONS = 'FAIL_FETCH_STATS_REGISTRATIONS';

export const fetchStatistics = (payload, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_STATS_REGISTRATIONS, payload, scope });

        fetch(getEndpoint('fetchStatsRegistrations', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
                if(data.error) dispatch({ type: FAIL_FETCH_STATS_REGISTRATIONS });
                else dispatch(successFetchStatistics(data, payload, scope));
            })
            .catch((error, type = FAIL_FETCH_STATS_REGISTRATIONS) => { dispatch({ type, error, payload, scope }); });
    };
};

function successFetchStatistics(data, payload, scope) {
    return dispatch => {
        const { totalUsers, newUsers } = data;
        const registrations = map(newUsers, (stat, date) => {
            return { ...stat, id: `registrations-${date}`, date }
        });

        const normalized = normalize(registrations, statisticListSchema);
        dispatch(receiveEntities(normalized.entities));

        dispatch({
            type: SUCCESS_FETCH_STATS_REGISTRATIONS,
            receivedAt: Date.now(),
            ids: normalized.result,
            total: totalUsers,
            payload,
            scope
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/registrations.js